/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_Status_Vo_CompleteInputs */



/**
* | output |
* | --- |
* | "VO Track complete..." |
*
* @param {Audio_Description_Export_Status_Vo_CompleteInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_status_vo_complete = /** @type {((inputs?: Audio_Description_Export_Status_Vo_CompleteInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Status_Vo_CompleteInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Piste VO terminée...")
	if (locale === "de") return /** @type {LocalizedString} */ ("VO-Spur abgeschlossen...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Traccia VO completata...")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Запись озвучки завершена...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Pista VO completa...")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("配音轨道已完成……")
	if (locale === "ja") return /** @type {LocalizedString} */ ("VOトラックが完了しました...")
	if (locale === "hi") return /** @type {LocalizedString} */ ("वॉयस ओवर ट्रैक पूरा हो गया...")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Faixa de narração concluída...")
	return /** @type {LocalizedString} */ ("VO Track complete...")
});